import { TextBoxMaxLine1FontLgBold } from 'atoms/TextBox/Templates'
import { ChooseAvatarAvatarsSC, ChooseAvatarSC } from './ChooseAvatar.styled'

export interface IChooseAvatar {
  title: string
  children: React.ReactNode
}

export const ChooseAvatar = ({ title, children }: IChooseAvatar) => {
  return (
    <ChooseAvatarSC>
      <TextBoxMaxLine1FontLgBold title={title} />

      <ChooseAvatarAvatarsSC>{children}</ChooseAvatarAvatarsSC>
    </ChooseAvatarSC>
  )
}
